import React, { useEffect, useState } from 'react'

const FinalNoteDisplayImaging = ({ diagnosisName, showDataIfNoteIsFollowUp = false, MasterDiagnosisData, contentEditable, imagingTypeList, imaging, noteStructureRef, showComment }) => {
  const lastImaging = imaging && imaging.length > 0 ? imaging[imaging.length - 1] : null

  const [matchingDiagnosisImaging, setMatchingDiagnosisImaging] = useState([])

  // useEffect(() => {
  //     if (imagingTypeList.length > 0 && lastImaging?.data && MasterDiagnosisData) {
  //         const lastImagingImpression = lastImaging.data.impression.toLowerCase();
  //         const lastImagingPatientSelectedImaging = lastImaging.data.name.toLowerCase();

  //         const findMatchingImagingMaster = imagingTypeList.find(item =>
  //             item.Name.toLowerCase() === lastImagingPatientSelectedImaging
  //         );

  //         if (findMatchingImagingMaster) {
  //             const matchingDiagnosisImaging = [];

  //             findMatchingImagingMaster.Keywords.forEach(keywordDetail => {
  //                 const keywordsArray = keywordDetail.keyword
  //                     .split(',')
  //                     .map(keyword => keyword.trim().toLowerCase())
  //                     .filter(keyword => keyword !== '');

  //                 if (keywordsArray.some(keyword => lastImagingImpression.includes(keyword))) {
  //                     matchingDiagnosisImaging.push(keywordDetail);
  //                 }
  //             });

  //             for (const remarkD of matchingDiagnosisImaging) {
  //                 const masterD = MasterDiagnosisData.find(item => item.id === Number(remarkD.diagnosis));

  //                 if (masterD && diagnosisName.trim() === masterD.Name.trim()) {
  //                     const imagingData = {
  //                         ...masterD,
  //                         ...remarkD,
  //                         ...lastImaging,
  //                     };

  //                     setMatchingDiagnosisImaging(imagingData);

  //                     // if (noteStructureRef && noteStructureRef.current) {
  //                     //     noteStructureRef.current = {
  //                     //         ...noteStructureRef.current,
  //                     //         imagingDetails: {
  //                     //             ...noteStructureRef.current.imagingDetails,
  //                     //             [diagnosisName]: imagingData,
  //                     //         },
  //                     //     };
  //                     // }

  //                     // return; // Exit the loop once a match is found
  //                 }
  //             }

  //             // If no match was found, reset state and noteStructureRef
  //             setMatchingDiagnosisImaging({});
  //             if (noteStructureRef && noteStructureRef.current) {
  //                 noteStructureRef.current = {
  //                     ...noteStructureRef.current,
  //                     imagingDetails: {
  //                         ...noteStructureRef.current.imagingDetails,
  //                         [diagnosisName]: {},
  //                     },
  //                 };
  //             }
  //         }
  //     }
  // }, [imagingTypeList, lastImaging, diagnosisName, MasterDiagnosisData, noteStructureRef]);

  console.log("matchingDiagnosisImaging",matchingDiagnosisImaging , noteStructureRef)

  useEffect(() => {
    if (imagingTypeList.length > 0 && MasterDiagnosisData && imaging.length > 0) {
      const matchedImagingList = []

      imaging.forEach((singleImaging) => {
        const impression = singleImaging?.data?.impression?.toLowerCase() || ''
        const selectedImagingName = singleImaging?.data?.name?.toLowerCase() || ''

        const matchedImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === selectedImagingName)

        if (matchedImagingMaster) {
          const keywordsList = Array.isArray(matchedImagingMaster?.Keywords) ? matchedImagingMaster.Keywords : []

          const matchedKeywords = keywordsList.filter((keywordDetail) => {
            const keywordsArray = (keywordDetail.keyword || '')
              .split(',')
              .map((k) => k.trim().toLowerCase())
              .filter(Boolean)

            return keywordsArray.some((keyword) => impression.toLowerCase().includes(keyword))
          })

          // const matchedKeywords = matchedImagingMaster.Keywords.filter(keywordDetail => {
          //     const keywordsArray = keywordDetail.keyword
          //         .split(',')
          //         .map(k => k.trim().toLowerCase())
          //         .filter(k => k);
          //     return keywordsArray.some(keyword => impression.includes(keyword));
          // });

          matchedKeywords.forEach((remarkD) => {
            const masterD = MasterDiagnosisData.find((item) => item.id === Number(remarkD.diagnosis))
            if (masterD && diagnosisName.trim() === masterD.Name.trim()) {
              matchedImagingList.push({
                ...masterD,
                ...remarkD,
                ...singleImaging,
              })
            }
          })
        }
      })

      setMatchingDiagnosisImaging(matchedImagingList)

      if (noteStructureRef && noteStructureRef.current) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          imagingDetails: {
            ...noteStructureRef.current.imagingDetails,
            [diagnosisName]: matchedImagingList.length > 0 ? matchedImagingList : [],
          },
        }
      }

      if (matchedImagingList.length === 0) {
        setMatchingDiagnosisImaging([])
        if (noteStructureRef && noteStructureRef.current) {
          noteStructureRef.current = {
            ...noteStructureRef.current,
            imagingDetails: {
              ...noteStructureRef.current.imagingDetails,
              [diagnosisName]: [],
            },
          }
        }
      }
    }
  }, [imagingTypeList, imaging, diagnosisName, MasterDiagnosisData, noteStructureRef])

  useEffect(() => {
    if (diagnosisName === 'Cognitive Communication Deficit') {
    }
  }, [])

  const validImagingDiagnosis = Array.isArray(matchingDiagnosisImaging)
  ? matchingDiagnosisImaging.filter(item =>
       noteStructureRef?.current?.metadata?.imagingIds?.includes(item?.id)
    )
  : []

  return (
    // <div>
    //     <div>
    //         {/* {matchingDiagnosisImaging && matchingDiagnosisImaging.data && (
    //             <>
    //                 <p className='text-warning'>{new Date(matchingDiagnosisImaging.date).toLocaleDateString('en-US')} : {matchingDiagnosisImaging.data.name}</p>
    //                 <p className='text-warning' >{matchingDiagnosisImaging.data.impression}</p>
    //                 {showComment && <p className='text-warning' >{matchingDiagnosisImaging.data?.comment}</p>}
    //             </>
    //         )
    //             :
    //                 <p>No Data</p>
    //         } */}
    //         <div>
    //             {matchingDiagnosisImaging?.data ? (
    //                 <>
    //                     <p className="text-warning">
    //                         {new Date(matchingDiagnosisImaging.date).toLocaleDateString('en-US')} :{" "}
    //                         {matchingDiagnosisImaging.data.name}
    //                     </p>
    //                     <p className="text-warning">{matchingDiagnosisImaging.data.impression}</p>
    //                     {showComment && (
    //                         <p className="text-warning">{matchingDiagnosisImaging.data.comment}</p>
    //                     )}
    //                 </>
    //             ) : (
    //                 <p></p>
    //             )}
    //         </div>

    //     </div>
    // </div>
   <div>
  <div>
    {Array.isArray(validImagingDiagnosis) &&
    validImagingDiagnosis.length > 0  ? (
      validImagingDiagnosis
        .sort((a, b) => {
          const priorityA = Number(a.data?.priority ?? 0)
          const priorityB = Number(b.data?.priority ?? 0)

          if (priorityA !== priorityB) {
            return priorityA - priorityB
          }

          return new Date(b.date) - new Date(a.date)
        })
        .map((item, index) => (
          <div key={index}>
            <p className="text-warning p-0 mb-1">
              {new Date(item.date).toLocaleDateString('en-US')} : {item.data.name}
            </p>
            <p style={{ whiteSpace: 'pre-wrap' }} className="text-warning">
              {item.data.impression}
            </p>
            {showComment && <p className="text-warning">{item.data.comment}</p>}
          </div>
        ))
    ) : (
      <p className="text-muted"></p>
    )}
  </div>
</div>
  )
}

export default FinalNoteDisplayImaging
